// @ts-nocheck

import { useEffect, useState } from 'react';

import useResponsive from '@/hooks/useResponsive';
import { useLayoutStore } from '@/stores/layout/layout.store';

import { chatbotButton, chatbotStyle } from './cssStyles';

const intercomAppId = process.env.NEXT_PUBLIC_CHAT ?? 'jwd56hxv';

const agent = {
  PE: '99-minutos-peru',
  CO: '99-minutos-colombia',
  CL: '99-minutos',
};

const intercomStarter = () => {
  var w = window;
  var ic = w.Intercom;

  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
    return;
  }

  var d = document;
  var i = function () {
    i.c(arguments);
  };

  i.q = [];
  i.c = function (args) {
    i.q.push(args);
  };

  w.Intercom = i;

  var l = function () {
    var s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${intercomAppId}`;
    var x = d.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  };

  if (document.readyState === 'complete') {
    l();
  } else if (w.attachEvent) {
    w.attachEvent('onload', l);
  } else {
    w.addEventListener('load', l, false);
  }
};

const ChatBot = () => {
  const [showChileChatbot, setShowChileChatbot] = useState('block');
  const [showModal, setShowModal] = useState('hidden');
  const validCountries = ['CL', 'PE', 'CO'];

  const country = useLayoutStore((state) => state.country);

  const isMobile = useResponsive('down', 'sm');

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (country != null && !validCountries.includes(country)) {
      intercomStarter();

      setShowChileChatbot('none');

      window.Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: intercomAppId,
      });
    } else {
      setShowChileChatbot('block');

      if (window.Intercom === undefined) return;
      window.Intercom('shutdown');
    }
  }, [country, window]);

  const handleChileModal = () => {
    if (showModal === 'hidden') {
      setShowModal('visible');
    } else {
      setShowModal('hidden');
    }
  };

  if (!validCountries.includes(country)) return <></>;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        zIndex: 100000000001,
        display: showChileChatbot,
      }}
    >
      <button onClick={handleChileModal} id="toggle-button" style={chatbotButton}>
        💬
      </button>
      <iframe
        id="chat-iframe"
        src={`https://www.smartup.lat/agente/${agent[country]}?mode=iframe`}
        style={chatbotStyle(showModal, isMobile)}
      ></iframe>
    </div>
  );
};

export default ChatBot;
